













// TODO: move variable definitions to shared assets
import '@/components/input/input-main.css';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'BaseInput',
})
export default class BaseInput extends Vue {
    // TODO: upgrade vue-property-decorator and replace modelWrapper get/set with VModel directive
    @Prop({ type: [String, Number] }) readonly  value!: string | number
    @Prop({ type: String, default: 'text' }) readonly type!: string
    @Prop({ type: String, default: '' }) readonly placeholder!: string
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

    get modelWrapper() { 
        return this.value;
    }

    set modelWrapper(value) {
        this.$emit('input', value);
    }

    onBlur() {
        this.$emit('blur');
    }
}
